const { currencyLocale } = require('../constants/currencies');
const { round } = require('../constants/math');
const { dayjs } = require('./date');

function numberFormat(value, opts, locale = 'en-GB') {
  return value != null ? new Intl.NumberFormat(locale, opts).format(value) : '';
}

function currencyFormat(value, opts, locale) {
  return value != null ? numberFormat(value, { style: 'currency', currency: 'EUR', maximumFractionDigits: 2, minimumFractionDigits: 0, ...opts }, locale || currencyLocale[opts?.currency || 'EUR']) : '';
}

function dateFormat(value, opts, locale = 'en-GB') {
  return value != null ? new Intl.DateTimeFormat(locale, { year: 'numeric', day: 'numeric', month: 'short', ...opts }).format(dayjs(value).toDate()) : '';
}

function timeFormat(value, opts, locale = 'en-GB') {
  return value != null ? new Intl.DateTimeFormat(locale, { hour: 'numeric', minute: 'numeric', ...opts }).format(dayjs(value).toDate()) : '';
}

function durationFormat(milliseconds) {
  if (milliseconds == null) {
    return '';
  }

  if (milliseconds < 2 * 1000) {
    return `${round(milliseconds / 1000, 3)}s`;
  }

  const seconds = Math.floor(milliseconds / 1000);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;

  if (hours > 0) {
    const formattedHours = hours < 10 ? `0${hours}` : hours;
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  return `${formattedMinutes}:${formattedSeconds}`;
}

function periodFormat(period, opts, locale = 'en-GB') {
  if (!period?.startDate || !period?.endDate) return '';

  const start = dateFormat(period.startDate, opts, locale);
  const end = dateFormat(period.endDate, opts, locale);

  return `${start}${start !== end ? ` - ${end}` : ''}`;
}

module.exports = {
  numberFormat,
  currencyFormat,
  dateFormat,
  timeFormat,
  durationFormat,
  periodFormat,
};
